// extracted by mini-css-extract-plugin
module.exports = {"container":"RegistrationForm_container__3xwnO","input":"RegistrationForm_input__9ZplU","ctaButton":"RegistrationForm_ctaButton__AYEGw"};